import { Constants } from "../constants/Contants";
import request from "../utils/useApi";
import { get, post } from '../utils/request';

export const getAllUsers = async () => {
  try {
    const res = await request.get(Constants.get_all_users_url);
    if (res) {
      return res;
    }
  } catch (e) {
    throw e;
  }
};
export const getOrdersByUserId = async (userId) => {
  try {
    const res = await request.get(
      Constants.get_orders_by_user_id_url + `/${userId}`
    );
    if (res) {
      return res;
    }
  } catch (e) {
    throw e;
  }
};

//   userId,
//   fullName,
//   email,
//   DOB,
//   gender,
//   currency,
//   country,
//   passportNumber,
//   phone
export const updateProfile = async (data) => {
  try {
    const result =  await post(Constants.updateProfile, data);
    return result;
  } catch (error) {
    console.error("Failed to update profile:", error);
    throw error;
  }
};